import { BaseElement } from './base-element';
import { ElementType } from './element-type';

export class Confirm extends BaseElement {
  header: string | null = null;
  message: string | null = null;
  messageList: string[] = [];
  confirmOptions: ConfirmOption[] = [];

  constructor() {
    super();
    this.elementType = ElementType.confirm;
  }
}

export interface ConfirmOption {
  text: string;
  value: boolean;
}
